<template>
  <div style="border: 1px solid #ccc">
    <Toolbar :default-config="toolbarConfig" :editor="editorRef" :mode="mode" style="border-bottom: 1px solid #ccc" />
    <Editor
      :key="indexValue"
      v-model="valueHtml"
      :default-config="editorConfig"
      :mode="mode"
      style="height: 500px; overflow-y: hidden"
      @onChange="handleChange"
      @onCreated="handleCreated"
    />
  </div>
</template>

<script>
  import '@wangeditor/editor/dist/css/style.css' // 引入 css

  import { onBeforeUnmount, ref, shallowRef, watch } from 'vue'
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
  import { upLoadImg } from '@/api/active'

  export default {
    name: 'EditorRich',
    components: { Editor, Toolbar },
    emits: ['contentChange'],
    props: {
      htmlValue: {
        type: String,
        default: '',
      },
      indexValue: {
        type: Number,
        default: 0,
      },
    },
    setup(props, { emit }) {
      // 编辑器实例，必须用 shallowRef
      const editorRef = shallowRef()

      // 内容 HTML
      const valueHtml = ref('')

      // watch(
      //   () => (newValue, oldValue) => {

      //   },
      //   { deep: true, immediate: true }
      // )

      watch(
        () => props.htmlValue,
        (newValue) => {
          const nextHtml = newValue || ''
          if (nextHtml !== valueHtml.value) {
            valueHtml.value = nextHtml
          }
        },
        { immediate: true }
      )

      const toolbarConfig = {
        excludeKeys: ['fullScreen', 'uploadVideo'],
      }
      const editorConfig = {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            async customUpload(file, insertFn) {
              console.log(file)
              let upData = new FormData()
              upData.append('file', file)
              const { data } = await upLoadImg(upData)
              insertFn(data, '图片', '')
            },
          },
        },
      }

      const setValue = (nval) => {
        const editor = editorRef.value
        editor.setHtml(nval.options.list[0].richText)
        // if (editor == null) return
        // editor.destroy()
      }

      const handleCreated = (editor) => {
        editorRef.value = editor // 记录 editor 实例，重要！
      }

      const handleChange = (editor) => {
        emit('contentChange', editor.getHtml(), props.indexValue)
      }

      onBeforeUnmount(() => {
        const editor = editorRef.value
        if (editor == null) return
        editor.destroy()
      })

      return {
        editorRef,
        valueHtml,
        mode: 'default', // 或 'simple'
        toolbarConfig,
        editorConfig,
        handleCreated,
        handleChange,
        setValue,
      }
    },
  }
</script>
